import T from '../types';

import getDestinationSuggestions from './getDestinationSuggestions';

export default (query = '', opts = {}) =>
  (dispatch) => {
    dispatch({ type: T.SET_DESTINATION_QUERY, query });

    if (opts.isSimplify) {
      return;
    }

    if (query.length > 1) {
      // eslint-disable-next-line consistent-return
      return dispatch(getDestinationSuggestions(query));
    }

    // eslint-disable-next-line consistent-return
    return dispatch({
      type: T.SET_DESTINATION_SUGGESTIONS,
    });
  };
